<template>
  <div class="containerForsyn" ref="content">
    <div slot="table-busy" class="text-center small text-dark my-5 pt-5" v-if="isBusy === true">
      <b-spinner class="align-middle mx-2"></b-spinner>
      <strong>Loading...</strong>
    </div>

    <div aria-busy="false" v-if="isBusy === false">
      <div class="bookingInfo">
        {{ name }}, {{ adress }} <br>
        Forsyn {{ dateForsyn }} kl {{ timeForsyn }} <br>
        Grävning {{ dateDigging }} kl {{ timeDigging }}
      </div>

      <h1><span>Kund</span></h1>

      <b-form @submit.prevent="setInputData(name, adress, postnr, ort, fastBet, email,
                    color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments,
                   dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat)">
        <div class="flex-grid">
          <div class="col">
            <b-form-group label="Namn">
              <b-form-input v-model="name" required/>
            </b-form-group>

            <b-form-group label="Ort">
              <b-form-input v-model="ort" required/>
            </b-form-group>

            <b-form-group label="E-post" description="">
              <b-form-input v-model="email" type="email" required/>
            </b-form-group>

            <b-form-group label="Fastighetsbet">
              <b-form-input v-model="fastBet" required />
            </b-form-group>

            <b-form-group label="Lat"> <!--@click="getLocation()"-->
              <b-form-input v-model="lat" />
            </b-form-group>
          </div>

          <div class="col">
            <b-form-group label="Adress">
              <b-form-input v-model="adress" required />
            </b-form-group>

            <b-form-group label="Postnr">
              <b-form-input v-model="postnr" required />
            </b-form-group>

            <b-form-group label="Telefon">
              <b-form-input v-model="phone" required />
            </b-form-group>

            <b-form-group label="Kundfärg:">
              <b-form-select v-model="color" :options="cable_colors" required class="rounded-0"/>
            </b-form-group>

            <b-form-group label="Long"> <!--@click="getLocation()"-->
              <b-form-input v-model="lon"/>
            </b-form-group>
          </div>

          <div class="col">
            <h4>Status</h4>
            <b-form-checkbox id="fk" value="fk" unchecked-value="fk_not_done" v-model="fk"  > Förprojektering klar </b-form-checkbox>
            <b-form-checkbox id="ttt" value="ttt" unchecked-value="ttt_not_done" v-model="ttt"> Tillträde till tomtmar </b-form-checkbox>
            <b-form-checkbox id="dthv" value="dthv" unchecked-value="dthv_not_done" v-model="dthv"> Duct till Husvägg </b-form-checkbox>
            <b-form-checkbox id="fthv" value="fthv" unchecked-value="fthv_not_done" v-model="fthv"> Fiber till Husvägg </b-form-checkbox>
            <b-form-checkbox id="invoiced" value="invoiced" unchecked-value="invoiced_not_done" v-model="invoiced"> Fakturerad </b-form-checkbox>

            <h4>Övrigt</h4>
            <b-form-checkbox v-model="lawnmover_checked" name="check-button-lawnmover" switch> Gräsklipparkabel </b-form-checkbox>
            <b-form-checkbox v-model="water_checked" name="check-button-water" switch> Sommarvattenslang </b-form-checkbox>
            <b-form-checkbox v-model="owncable_checked" name="check-button-owncable" switch> Belysningskabel eller egen kabel </b-form-checkbox>
          </div>
          <div class="col"/>
        </div>

        <!--<button class="greenSea getLocation" @click="getLocation()">Hitta koordinater</button>-->

        <div class="flex-grid">
          <div class="col">
            <b-form-group label="Kommentarer">
              <b-form-textarea v-model="customerComments" placeholder="Kundkommentarer" rows="7" max-rows="20" autofocus />
            </b-form-group>
          </div>
        </div>

        <h1><span>Tid</span></h1>
        <div class="flex-grid">
          <div class="col">
            <h4>Planerad försyn</h4>
            <flat-pickr v-model="dateForsyn" placeholder="Välj datum"></flat-pickr>
          </div>

          <div class="col">
            <h4>Önskad tid</h4>
            <vue-single-select
                    v-model="timeForsyn"
                    :options="tForsyn"
                    placeholder="Sök tid"
                    value=""/>
          </div>

          <div class="col"></div>
          <div class="col"></div>
        </div>

        <div class="flex-grid">
          <div class="col">
            <h4>Planerad grävning</h4>
            <flat-pickr v-model="dateDigging" placeholder="Välj datum"></flat-pickr>
          </div>

          <div class="col">
            <h4>Önskad tid</h4>
            <vue-single-select
                    v-model="timeDigging"
                    :options="tDigging"
                    placeholder="Sök tid"
                    value=""/>
          </div>

          <div class="col"></div>
          <div class="col"></div>
        </div>

        <h1><span>Bilder</span></h1>
        <div class="flex-grid">
          <div class="col">
            <h4>Välj bildkategori </h4>
            <div class="select-dropdown">
              <label>
                <select v-on:change="getText" v-model="imgCategory">
                  <option v-for="choice in choices" v-bind:value="choice.value">{{ choice.text }}</option>
                </select>
              </label>
            </div>
          </div>

          <div class="col">
            <div class="base-image-input"
                 :style="{ 'background-image': `url(${imageData})` }" v-on:click="chooseImage">
          <span v-if="!imageData" class="placeholder">
                Välj bild
            </span>
              <!--      v-bind:imagetype="images_forsyn + choiceText"-->
              <input class="file-input" ref="fileInput" type="file" v-on:change="onSelectFile($event, choiceText)">
              <!-- v-on:input="onSelectFile($event, choiceText)"-->
            </div>
          </div>
          <div class="col"></div>
          <div class="col"></div>
          <div class="col"></div>
          <div class="col"></div>
        </div>
        <br>

        <div class="flex-grid">
          <div class="col"></div>
          <div class="col">
            <div class="alert" v-if="alert" role="alert">
              <h4 class="alert-heading"> Ärendet är sparat! <br>
                Uppdatera sidan</h4>
            </div>
            <div class="alert" v-if="imgAlert" role="alert">
              <h4 class="alert-heading"> Bilden är sparad! <br>
                Uppdatera sidan</h4>
            </div>
          </div>
          <div class="col"></div>
        </div>

        <div class="flex-grid buttonGroup">
          <b-button type="submit" class="button greenSea"> Spara </b-button>
          <b-button type="reset" class="button red" @click="deleteForsyn()">Radera kund</b-button>
        </div>
      </b-form>

      <div class="imgContainer">
        <div class="flex-grid">
          <div class="col" v-if="images_forsyn!=''">
            <h1><span>Försyn</span></h1>
            <img class="image" v-for="(image, i) in images_forsyn" :src="image" :key="i" @click="images_forsyn_index = i">
            <vue-gallery-slideshow :images="images_forsyn" :index="images_forsyn_index" @close="images_forsyn_index = null"></vue-gallery-slideshow>
          </div>

          <div class="col" v-if="images_before!=''">
            <h1><span>Före</span></h1>
            <img class="image"  v-for="(image, i) in images_before" :src="image" :key="i" @click="images_before_index = i">
            <vue-gallery-slideshow :images="images_before" :index="images_before_index" @close="images_before_index = null"></vue-gallery-slideshow>
          </div>
        </div>

        <div class="flex-grid">
          <div class="col" v-if="images_digging!=''">
            <h1><span>Grävning</span></h1>
            <img class="image" v-for="(image, i) in images_digging" :src="image" :key="i" @click="images_digging_index = i">
            <vue-gallery-slideshow :images="images_digging" :index="images_digging_index" @close="images_digging_index = null"></vue-gallery-slideshow>
          </div>

          <div class="col" v-if="images_after!=''">
            <h1><span>Efter</span></h1>
            <img class="image" v-for="(image, i) in images_after" :src="image" :key="i" @click="images_after_index = i">
            <vue-gallery-slideshow :images="images_after" :index="images_after_index" @close="images_after_index = null"></vue-gallery-slideshow>
          </div>
        </div>

        <div class="flex-grid">
          <div class="col" v-if="images_other!=''">
            <h1><span>Övrigt</span></h1>
            <img class="image" v-for="(image, i) in images_other" :src="image" :key="i" @click="images_other_index = i">
            <vue-gallery-slideshow :images="images_other" :index="images_other_index" @close="images_other_index = null"></vue-gallery-slideshow>
          </div>

          <div class="col"/>
        </div>
      </div>
    </div>
    <back-to-top text="Back to top" visibleoffset="500" class="btn-to-top">Scroll to top</back-to-top>
  </div>
</template>

<script>

  /* Input box - upload img
   https://codepen.io/tahazsh/pen/KrYwQb?source=post_page
  * https://levelup.gitconnected.com/how-to-preview-images-before-uploading-them-in-vue-4964803adb64*/

  import {db, fbapp} from '../main'
  import {storage} from 'firebase';
  import VueGallery from 'vue-gallery';
  import VueGallerySlideshow from 'vue-gallery-slideshow';
  import VueSingleSelect from "vue-single-select";
  import BackToTop from 'vue-backtotop';

  export default {
    name: "forsyn",
    components: {
      'gallery':
      VueGallery,
      VueGallerySlideshow,
      VueSingleSelect,
      BackToTop
    },

    data() {
      return {
        isBusy: true,
        alert: false,
        imgAlert: false,
        createdAt: new Date(),
        msg: String,
        imageFile: null,
        imgCategory: '',
        imgCategories: ["Före", "Försyn", "Grävning", "Efter", "Övrigt"],
        timeForsyn: 'Not Defined',
        timeDigging: 'Not Defined',
        tForsyn: ['9-11', '12-14', 'Not Defined'],
        tDigging: ['9-11', '12-14', 'Not Defined'],
        dateDigging: 'Not Defined',
        dateForsyn: 'Not Defined',
        choices: [
          {value: "forsyn", text: "Försyn"},
          {value: "before", text: "Före"},
          {value: "digging", text: "Grävning"},
          {value: "after", text: "Efter"},
          {value: "other", text: "Övrigt"},
        ],
        choiceId: '',
        name: '',
        adress: '',
        postnr: '',
        ort: '',
        fastBet: '',
        email: '',
        color: '',
        phone: '',
        fk: false,
        ttt: false,
        dthv: false,
        fthv: false,
        invoiced: false,
        lawnmover_checked: false,
        water_checked: false,
        owncable_checked: false,
        customerComments: null,
        cable_colors: [{text: 'Välj färg på duct', value: null},
          'VI', 'BL', 'BR', 'GR', 'VL', 'GRÅ', 'RO', 'RÖ', 'SV', 'TU', 'OR', 'GU'],
        customers: [],
        images_forsyn: [],
        images_forsyn_index: null,
        images_before: [],
        images_before_index: null,
        images_after: [],
        images_after_index: null,
        images_digging: [],
        images_digging_index: null,
        images_other: [],
        images_other_index: null,
        image: '',
        imageUrl: '',
        imageData: '',  // we will store base64 format of image in this string
        images: [],
        index: null,
        saveImages: [],
        choiceText: '',
        noImages: null,
        lon: 'Not Defined',
        lat: 'Not Defined',
        items: [],
        key: '',
        fileImg: '',
        fileName: ''
      }
    },

    async beforeMount() {
      this.isBusy = true;
      await this.getForsynIDAndSetForsynID();       // Sätter försyn ID,
      await this.firestore();                       // Hämtar firebase
    },

    methods: {
      firestore() {
        return {
          customers: db.collection('customers'),
          customer_images: db.collection('customers_images')
        }
      },

      /* Sparar ID i vuex  */
      async getForsynIDAndSetForsynID() {
        await this.setForsynID(this.$route.params.id);                 // Tilldelar ID i redux
        await this.getForsynID();
        await this.getForsynData(this.$route.params.id);
      },

      /* Om det finns ID, Radera tidigare ID och Spara nytt ID globalt i Vuex */
      setForsynID(forsynID) {
        if ((forsynID !== undefined) && (forsynID !== null) && (forsynID !== '')) {
          this.deleteForsynID();
          this.$store.commit('ADD_TO_ID', forsynID);
        } else {
          console.log(('ID is undefined, null or empty '))
        }
      },

      getForsynID() {              // Hämtar ID ifrån store getters
        return this.$store.getters.forsynID;
      },

      deleteForsynID(ID) {                    /* Tar bort sparade ID */
        this.$store.commit('DELETE_ID', ID);
      },

      /* If it´s possible to retrieve current geo location, get showLocation */
      getLocation: function () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.showLocation);
        } else {
          this.error = "Geolocation is not supported.";
        }
      },

      /* Retrieving geo current location and display current coordinates */
      showLocation: function (position) {
        let lat = this.lat = position.coords.latitude;
        let lon = this.lon = position.coords.longitude;
        //this.setMap(lat, lon);
      },

      getText() {
        const values = this.choices.map(function (o) {
          return o.value
        });
        const index = values.indexOf(this.imgCategory);
        this.saveNewImages(this.choiceText = this.choices[index].value);
      },

      saveNewImages(images) {
        this.saveImages.push(this.images);
      },

      chooseImage() {
        this.$refs.fileInput.click();
      },

      onSelectFile($event, imgCategory) {
        const input = this.$refs.fileInput;
        const files = input.files;
        if (files && files[0]) {
          const reader = new FileReader;
          reader.onload = e => {
            this.imageData = e.target.result
          };
          reader.readAsDataURL(files[0]);
          this.$emit('input', files[0]);
          this.onFilePicked($event, imgCategory);
        }
      },

      async onFilePicked($event, imgCategory) {
        if (imgCategory === '' || imgCategory === undefined && false) {
          alert('Välj bild kategori');
          console.log('Välj bild kategori');
        } else {                                        // Om bildkategori är vald
          await $event.target.files;                      // Hämta bilden och invänta tills det är klart.
          let files = $event.target.files;
          let filename = files[0].name;                   // Hämta bild namnet
          let fileImg = files[0];                        // Hämta bilden
          await this.upDateImgURL(filename, fileImg);    // Skickar filnamet och bilden till uppdatering i firebase. Vänta tills funktionen är körd
        }
      },

      upDateImgURL(filename, fileImg) {
        let auth = fbapp.auth().currentUser.uid;        // Hämtar firebase ID
        let userID = this.getForsynID()[0];             // Hämtar user ID ifrån state

        let imgStorage = 'customers_images/';
        let imgFolder = 'customers_images_';

        db.collection(imgFolder + userID).add({           // Uppdatera i firebase med folder och userID
          forsynID: auth,                                     // Spara bilden med firebase AUTH
          imageUrl: this.imageUrl,                            // Spara bilden med image URL
          imageType: this.imgCategory,                       // Spara bilden med  categori
          dateTime: new Date(),                             // Spara bilden med  dagens datum och tid
        }).then((data) => {
          this.key = data.id;                               // Spara firebase ID
          return fbapp.storage().ref(imgStorage + this.key + filename).put(fileImg)
        }).catch((error) => {
          console.log(error)
        }).then(fileData => {
          return fileData.ref.getDownloadURL();
        }).catch((error) => {
          console.log(error)
        }).then((imageUrl) => {
          this.imageUrl = imageUrl;
          db.collection(imgFolder + userID).doc(this.key)
                  .update({
                    imageUrl: imageUrl
                  });
          this.imgAlert = true;       // Show img alert
        }).catch((error) => {
          console.log(error)
        });
        setTimeout(() => {             // Hide alert after sec
          this.imgAlert = false;
        }, 3000)
      },

      getForsynData(forsynID) {
        this.isBusy = true;
        const docRef = db.collection('customers').doc(forsynID).get().then(doc => {
          const docData = doc.data();
          this.name = docData.name;
          this.adress = docData.adress;
          this.postnr = docData.postnr;
          this.ort = docData.ort;
          this.email = docData.email;
          this.color = docData.color;
          this.phone = docData.phone;
          this.fastBet = docData.fastBet;
          this.fk = docData.fk;
          this.ttt = docData.ttt;
          this.dthv = docData.dthv;
          this.fthv = docData.fthv;
          this.invoiced = docData.invoiced;
          this.lawnmover_checked = docData.lawnmover_checked;
          this.water_checked = docData.water_checked;
          this.owncable_checked = docData.owncable_checked;
          this.customerComments = docData.customerComments;
          this.dateForsyn = docData.dateForsyn;
          this.dateDigging = docData.dateDigging;
          this.timeForsyn = docData.timeForsyn;
          this.timeDigging = docData.timeDigging;
          this.lon = docData.lon;
          this.lat = docData.lat;
        }).then(resp => {
          let imagesRef = db.collection("customers_images_" + this.getForsynID()[0]).get().then(images => {
            let data = images.docs.map(function (doc) {
              return doc.data();
            });
            data.forEach(function (doc) {
              switch (doc.imageType) {
                case "before":
                  this.images_before.push(doc.imageUrl);
                  break;
                case "after":
                  this.images_after.push(doc.imageUrl);
                  break;
                case "forsyn":
                  this.images_forsyn.push(doc.imageUrl);
                  break;
                case "digging":
                  this.images_digging.push(doc.imageUrl);
                  break;
                case "other":
                  this.images_other.push(doc.imageUrl);
                  break;
                default:
                  this.images_other.push(doc.imageUrl);
              }
            }.bind(this));
            this.isBusy = false;
          });
        })
      },

      async getStorage() {
        return storage;
      },

      getStringID() {
        return JSON.stringify(this.getForsynID());
      },

      async updateCustomer() {
        this.isBusy = true;
        await db.collection('customers').get().then(resp => {
          let forsynListCollection = [];
          resp.forEach(doc => {
            const forsynListData = doc.data();
            forsynListCollection.push({
              'id': doc.id,
            })
          });
          this.items = forsynListCollection;
        });
        for (let i = 0; i < this.items.length; i++) {
          console.log(this.items[i++].id);
          /*          await db.collection('customers').doc(this.items[i]).update({
                      lat: '0',
                      lon: '0',
                      dateForsyn: '',
                      timeForsyn: 'Not Defined',
                      dateDigging: '',
                      timeDigging: 'Not Defined',
                    }).then(function () {
                      console.log("Document successfully updated!");
                    }).catch(function (error) {
                      console.error("Error removing document: ", error);
                    });*/
          //await this.$router.replace('/forsyn-list')
        }
      },

      async setInputData(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced,
                         lawnmover_checked, water_checked, owncable_checked, customerComments,
                         dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat) {

        console.log('SetinputData: ' + name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv,
                invoiced, lawnmover_checked, water_checked, owncable_checked,
                customerComments, dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat);

        if (dateDigging === '') {
          dateDigging = null;
        }
        if (dateForsyn === '') {
          dateForsyn = null;
        }
        if (timeDigging === '') {
          timeDigging = null;
        }
        if (timeForsyn === '') {
          timeForsyn = null;
        }

        await this.addNewForsyn(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced,
                lawnmover_checked, water_checked, owncable_checked, customerComments, dateForsyn, dateDigging, timeDigging, timeForsyn, lon, lat);
      },

      async addNewForsyn(name, adress, postnr, ort, fastBet, email,
                         color, phone, fk, ttt, dthv, fthv, invoiced,
                         lawnmover_checked, water_checked, owncable_checked, customerComments,
                         dateForsyn, dateDigging, timeDigging, timeForsyn, lon, lat) {

        const ID = this.getForsynID()[0];

        await db.collection('customers').doc(ID).update({
          name, adress, postnr, ort, fastBet, email,
          color, phone, fk, ttt, dthv, fthv, invoiced,
          lawnmover_checked, water_checked, owncable_checked, customerComments,
          dateForsyn, dateDigging, timeDigging, timeForsyn, lon, lat
        }).catch(function (error) {
          console.error("Error writing document: ", error);
          alert("Error writing document, try again");
        });
        this.showAlert();             // Show alert

        await setTimeout(() => {        // Hide alert after 3 sec
          this.hideAlert()
        }, 3000);
        // await this.$router.replace('/forsyn-list')   //Skicka vidare till försynList
      },

      showAlert() {
        this.alert = true;
      },

      hideAlert() {
        this.alert = false;
      },

      showimgAlert() {
        this.imgAlert = true;
      },

      hideimgAlert() {
        this.imgAlert = false;
      },

      /* Raderar en försyn */
      async deleteForsyn() {
        const ID = this.getForsynID()[0];
        await db.collection('customers').doc(ID).delete();
        await this.$router.replace('/forsyn-list');   //Skickas vidare till försynList
      },

      /* Raderar alla bilder */
      async deleteImgs() {
        const ID = this.getForsynID()[0];
        await db.collection('customers_images_' + ID).delete();
        await this.$router.replace('/forsyn-list');   //Skickas vidare till försynList
      }
    }
  }
</script>

<style scoped lang="scss">
  .btn-to-top {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 80px;
    min-width: 150px;
    padding: 10px 15px;
    color: #333;
    border: 1px solid transparent;
    line-height: 2;
    font-size: 14px;
    background: rgba(238, 238, 238, 0.9);
    border-radius: 0;
    box-shadow: 0 1px 3px rgba(238, 238, 238, 0.12), 0 1px 2px rgba(238, 238, 238, 0.24);
    transition: color 0.2s ease, background-color 0.2s ease, transform 0.3s ease;
    font-weight: 400;
    overflow: hidden;
    bottom: 100px!important;
    right: 100px!important;

  }
  .containerForsyn {
    max-width: 60%;
  }

  .buttonGroup {
    display: flex;
    justify-content: space-evenly;
    margin: 10px 0 20px 0;
  }
  .imgContainer {
    margin: 10px 0;
  }
  h1 {
    margin: 20px 0;
    font-size: 22px;
    min-width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 1;
    &:before {
      border-top: 2px solid #dfdfdf;
      content: "";
      margin: 0 auto; /* this centers the line to the full width specified */
      position: absolute; /* positioning must be, and relative positioning must be applied to the parent */
      top: 50%;
      left: 0;
      right: 0;
      bottom: 0;
      width: 95%;
      z-index: -1;
    }
    span { /* to hide the lines from behind the text, you have to set the background color the same as the container */
      background: #fff;
      padding: 0 10px;
    }
  }
  h4 {
    margin-top: 10px;
    font-weight: 300;
    font-size: 16px;
    z-index: 1;
  }
  .alert {
    z-index:999;
    position: absolute;
    padding : 20px;
    display: flex;
    justify-content: center;
    margin: auto;
    background-color: #B0E0E6;
  }
  .alert-heading{
    display: flex;
    justify-content: center;
    padding: 5px;
  }

  .bookingInfo {
    font-weight: 300;
    display: flex;
    justify-content: center;
    margin: auto;
    padding: 10px;
    border-radius: 4px;
    max-width: 50%;
    font-size: 12pt;
    background-color: #B0E0E6;
  }

  p {
    margin: 5px;
    font-style: italic;
  }

  .flex-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .col {
    flex-basis: 30%;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
  }

  input, button,input[type=date] {
    padding: 5px 10px;
    border-radius: 2px;
    border: 1px solid #ddd;
  }

  button {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    padding: 6px 15px;
    font-size: 10pt;
    letter-spacing: -0.3;
    min-width: 130px;
    line-height: 2;
  }

  .button:hover,
  .button:active,
  .button:focus,
  .button:visited {
    box-shadow: none;
    border: 1px solid transparent;
  }

  .getLocation {
    z-index: 5;
  }

  //Kundfärg drop dopwn
  .custom-select, .flatpickr-input {
    font-size: 10pt;
    font-weight: 300;
    margin: 0;
    color: #333;
  }

  .custom-control {
    margin: 5px 0 0 0;
  }

  textarea.form-control {
    font-size: 10pt;
    border-radius: 2px;
    border: 2px solid #ddd;
  }

  .image-preview {
    padding: 20px;
  }

  img .preview {
    width: 200px;
    background-color: white;
    padding: 5px;
  }

  img {
    padding: 10px 0;
  }

  .image {
    max-width: 100%;
    margin: auto;
  }

  label, legend {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-weight: 400;
    font-size: 16pt;
    padding: 0;
    margin: 0;
  }

  .select-dropdown {
    background-color: white;
    max-width: 45%;

    select {
      font-family: Raleway, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif;
      font-weight: 300;
      color: #333;
      font-size: 12pt;
      max-width: 100%;
      padding: 8px 10px;
      border: 1px solid #ced4da;
      border-radius: 2px;
      background-color: transparent;
      &:active,
      &:focus {
      }
    }
    &:after {
      content: " ";
      position: absolute;
      top: 7%;
      right: 60%;
      width: 0;
      height: 0;
    }
  }
  .base-image-input {
    margin: 20px 0;
    display: block;
    width: 100px;
    height: 100px;
    cursor: pointer;
    background-repeat: no-repeat;
  }
  .placeholder {
    background: #F0F0F0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 16px;
    font-weight: 400;
    font-family: Raleway, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif;
  }
  .placeholder:hover {
    background: #E0E0E0;
  }
  .file-input {
    display: none;
  }

  @media only screen and (max-width: 1400px) {
    .containerForsyn {
      min-width: 80%;
    }
    .btn-to-top {
      font-size: 18pt;
    }
  }

  @media only screen and (max-width: 992px) {
    .containerForsyn {
      min-width: 100%;
    }
    .col {
      flex-basis: 30%;
      margin: 5px 0;
    }
    button {
      padding: 5px 10px;
    }
    select {
      font-size: 10pt;
    }
    .bookingInfo {
      padding: 10px 0;
      max-width: 80%;
      font-size: 10pt;
    }
    h1 {
      margin: 10px 0;
      min-width: 100%;
    }
    h4 {
      margin-top: 10px;
      font-size: 18px;
    }
    input {
      padding: 5px 7px;
      font-size: 10pt;
      color: #333;
    }
    .placeholder {
      font-size: 14px;
    }
    .select-dropdown select[data-v-1fca8079] {
      margin: 0 15px;
      font-size: 12pt;
      padding: 6px 10px;
      font-weight: 400;
    }
    label, legend {
      font-size: 18pt;
    }
  }

  @media (max-width: 400px) {
    .flex-grid {
      display: block;
    }
  }
</style>
<!-- Du kan animera både på v-if (vanligast) och på v-show-->



// WEBPACK FOOTER //
// src/views/forsyn.vue